import React from "react";

const SvgComponent = props => (
  <svg width={40.367} height={40.973} viewBox="0 0 40.367 40.973" {...props}>
    <g fill="#83a5b3">
      <path d="M22.594 1.79a1.79 1.79 0 10-3.58 0l.001 3.977c0 .988.802 1.791 1.79 1.791a1.79 1.79 0 001.789-1.791V1.79zM8.632 6.078A1.79 1.79 0 006.1 8.61l2.812 2.811a1.79 1.79 0 002.532-2.53L8.632 6.078zM1.791 18.377a1.791 1.791 0 00-.001 3.58h3.977a1.791 1.791 0 000-3.58H1.791zM6.078 32.944a1.79 1.79 0 102.532 2.531l2.811-2.812c.7-.699.7-1.833 0-2.531a1.792 1.792 0 00-2.531.001l-2.812 2.811zM18.982 39.181a1.791 1.791 0 103.581 0v-3.977a1.792 1.792 0 00-3.581-.001v3.978zM32.945 35.499a1.79 1.79 0 102.531-2.531l-2.812-2.812a1.788 1.788 0 10-2.531 2.53l2.812 2.813zM38.576 22.595a1.791 1.791 0 00.002-3.581h-3.977a1.79 1.79 0 100 3.579l3.975.002zM35.498 8.632a1.79 1.79 0 00-2.531-2.53l-2.811 2.812a1.79 1.79 0 102.531 2.531l2.811-2.813zM20.805 9.7C14.66 9.7 9.68 14.681 9.68 20.827s4.981 11.127 11.125 11.127c6.146 0 11.127-4.981 11.127-11.127 0-6.145-4.981-11.127-11.127-11.127zm0 18.701a7.576 7.576 0 117.576-7.574 7.576 7.576 0 01-7.576 7.574z" />
    </g>
  </svg>
);

export default __webpack_public_path__ + "static/media/01d.d37bc50c.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/assets/weather-icons/01d.svg